import type { Jsonable } from "@/utils"

export const setStorageValue = (key: string, value: Jsonable) => {
  localStorage.setItem(key, JSON.stringify(value))
}

/** Undefined when the key is missing; null is a stored value. */
export const getStorageValue = <TValue extends Jsonable>(
  key: string,
): TValue | undefined => {
  const jsonValue = localStorage.getItem(key)

  return jsonValue ? (JSON.parse(jsonValue) as TValue) : undefined
}

export const removeStorageValue = (key: string) => {
  localStorage.removeItem(key)
}

export const onStorageChange = <TValue extends Jsonable>(
  key: string,
  callback: (value: TValue) => void,
) => {
  const onValueChanged = (event: StorageEvent) => {
    if (event.key !== key) {
      return
    }

    const value = getStorageValue<TValue>(key)
    // Cleared in the other tab (signing out, say). There is no new value to
    // report, and raising here would only surface as an uncaught error.
    if (value === undefined) {
      return
    }

    callback(value)
  }

  window.addEventListener("storage", onValueChanged)

  return () => {
    window.removeEventListener("storage", onValueChanged)
  }
}
